import React, { lazy } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { AppRouteURL } from "@Src/routes/app-route-urls";
import Loader from "@Components/loader/Loader";
import "primeicons/primeicons.css";
import { useAppSelector } from "@Src/app/hooks/hooks";


const Home = lazy(() =>
  import("@Pages/home/Home").then(({ Home }) => ({ default: Home }))
);

const Dashboardlazy = lazy(() =>
  import("@Pages/dashboard/Dashboard").then(({ Dashboard }) => ({ default: Dashboard }))
);
const DashboardDetailLazy = lazy(() =>
  import("@Pages/dashboarddetails/DashboardDetails").then(({ DashboardDetails }) => ({ default: DashboardDetails }))
);
const UpcomingLazyPage = lazy(() => import("@Pages/upcoming-events/UpcomingEvents"));
const RecentlyUploadedLazy = lazy(() => import("@Pages/recently-uploaded/RecentlyUploaded"));
const PracticeAreaLazy = lazy(() => import("@Pages/practice-area/PracticeArea"));
const MyLibraryLazy = lazy(() => import("@Pages/my-library/MyLibrary"));

const ProductSearchPage = lazy(() =>
  import("@Pages/videos/search/product-search").then(
    ({ VideoSearchPage }) => ({ default: VideoSearchPage })
  )
);
const AllReviewsPage = lazy(() =>
  import("@Pages/review/all-reviews/AllReviews").then(({ AllReviewsPage }) => ({ default: AllReviewsPage }))
);

const WriteReview = lazy(() =>
  import("@Pages/review/write-review/WriteReview").then(({ WriteReview }) => ({
    default: WriteReview,
  }))
);

const CheckoutPaymentPage = lazy(() =>
  import("@Pages/checkout/checkout-payment/checkout-payment").then(({ CheckoutPaymentPage }) => ({
    default: CheckoutPaymentPage,
  }))
);

const CheckoutInformationPage = lazy(() =>
  import("@Pages/checkout/checkout-information/checkout-information").then(({ CheckoutInformationPage }) => ({
    default: CheckoutInformationPage,
  }))
);

const PaymentSuccess = lazy(() =>
  import("@Components/custom/payment/payment-success/payment-success").then(({ PaymentSuccess }) => ({
    default: PaymentSuccess,
  }))
);
const PaymentFail = lazy(() =>
  import("@Components/custom/payment/payment-failed/payment-fail").then(({ PaymentFail }) => ({
    default: PaymentFail,
  }))
);

const OrderDetail = lazy(() =>
  import("@Pages/orderDetail/OrderDetail").then(({ OrderDetail }) => ({
    default: OrderDetail,
  }))
);

const RetryPayment = lazy(() =>
  import("@Src/features/payment/retry-payment/retry-payment").then(({ RetryPayment }) => ({
    default: RetryPayment,
  }))
)

const CollaborateWithUs = lazy(() =>
  import("@Src/pages/collaborate-with-us/CollaborateWithUs").then(({ CollaborateWithUs }) => ({
    default: CollaborateWithUs,
  }))
)

const Certificate = lazy(() =>
  import("@Src/pages/certificate/Certificate").then(({ Certificate }) => ({
    default: Certificate,
  }))
)

const NotFound = lazy(() =>
  import("@Src/pages/notFound").then(({ NotFound }) => ({
    default: NotFound,
  }))
)
const ViewAllLazy = lazy(() => import("@Components/view-all/ViewAll"))
const PracticeViewAllLazy = lazy(() => import("@Components/UI/practice-view-all/PracticeTypeViewAll"))
export default function AppRoutes() {
  const practiceViewAllPage = useAppSelector(selector => selector.global).practiceViewAllPage;
  const viewAllPage = useAppSelector(selector => selector.global).viewAllPage;
  const searchAllPage = useAppSelector(selector => selector.global).searchAllPage;
  const upcomingAllPage = useAppSelector(selector => selector.global).upcomingAllPage;

  return (
    <>
      <Routes>
        <Route
          path={AppRouteURL.HOME}
          element={
            <React.Suspense fallback={<Loader />}>
              <Home />
            </React.Suspense>
          }
        />

        <Route
          path={AppRouteURL.DASHBOARD}
          element={
            <React.Suspense fallback={<Loader />}>
              <Dashboardlazy />
            </React.Suspense>
          }
        />
        <Route
          path={AppRouteURL.UPCOMING_EVENTS}
          element={
            <React.Suspense fallback={<Loader />}>
              {upcomingAllPage && <UpcomingLazyPage />}
            </React.Suspense>
          }
        />
        <Route
          path={AppRouteURL.EVENTS}
          element={
            <React.Suspense fallback={<Loader />}>
              {viewAllPage && <ViewAllLazy title={"Events"} breadcrumbs={[{
                label: "Events"
              }]} />}
            </React.Suspense>
          }
        />
        <Route
          path={AppRouteURL.WEBIBAR_EVENTS}
          element={
            <React.Suspense fallback={<Loader />}>
              {viewAllPage && <ViewAllLazy category={"1"} title={"Webinars"} status={"past"} breadcrumbs={[{
                label: "Events",
                url: "/events",
              }, {
                label: "Webinar"

              }]} />}
            </React.Suspense>
          }
        />
        <Route
          path={AppRouteURL.WORKSHOP_EVENTS}
          element={
            <React.Suspense fallback={<Loader />}>
              {viewAllPage && <ViewAllLazy category={"2"} title={"Workshops"} status={"past"} breadcrumbs={[{
                label: "Events",
                url: "/events",
              }, {
                label: "Workshop"

              }]} />}
            </React.Suspense>
          }
        />
        <Route
          path={AppRouteURL.MASTERCLASS_EVENTS}
          element={
            <React.Suspense fallback={<Loader />}>
              {viewAllPage && <ViewAllLazy category={"3"} title={"Masterclasses"} status={"past"} breadcrumbs={[{
                label: "Events",
                url: "/events",
              }, {
                label: "Masterclass"

              }]} />}
            </React.Suspense>
          }
        />

        <Route
          path={AppRouteURL.RECOMENDED_EVENTS}
          element={
            <React.Suspense fallback={<Loader />}>
              {viewAllPage && <ViewAllLazy title={"Recommended Videos"} status={"past"} breadcrumbs={[{
                label: "Recommended Videos"

              }]} />}
            </React.Suspense>
          }
        />


        <Route
          path={AppRouteURL.PRACTICE_AREA}
          element={
            <React.Suspense fallback={<Loader />}>
              <PracticeAreaLazy />
            </React.Suspense>
          }
        />


        <Route
          path={AppRouteURL.PRACTICE_AREA + "/:subject"}
          element={
            <React.Suspense fallback={<Loader />}>
              {practiceViewAllPage && <PracticeViewAllLazy />}
            </React.Suspense>
          }
        />

        <Route
          path={AppRouteURL.PRODUCT_SEARCH_PAGE}
          element={
            <React.Suspense fallback={<Loader />}>
              {searchAllPage && <ProductSearchPage />}
            </React.Suspense>
          }
        />





        {/* <Route
          path={AppRouteURL.VIEW_ALL}
          element={
            <React.Suspense fallback={<Loader />}>
              {viewAllPage && <ViewAllLazy />}
            </React.Suspense>
          }
        /> */}

        <Route
          path={AppRouteURL.DASHBOARDDETAILS}
          element={
            <React.Suspense fallback={<Loader />}>
              <DashboardDetailLazy />
            </React.Suspense>
          }
        />


        {/* <Route
          path={AppRouteURL.PAST_EVENTS}
          element={
            <React.Suspense fallback={<Loader />}>
              <RecentlyUploadedLazy />
            </React.Suspense>
          }
        /> */}
        {/* <Route
          path={AppRouteURL.PRACTICE_AREA}
          element={
            <React.Suspense fallback={<Loader />}>
              <PracticeAreaLazy />
            </React.Suspense>
          }
        /> */}
        <Route
          path={AppRouteURL.MY_LIBRARY}
          element={
            <React.Suspense fallback={<Loader />}>
              <MyLibraryLazy />
            </React.Suspense>
          }
        />

        <Route
          path={':event_id/customer-reviews'}
          element={
            <React.Suspense fallback={<Loader />}>
              <AllReviewsPage />
            </React.Suspense>
          }
        />




        <Route
          path={':eventId/write-a-review'}
          element={
            <React.Suspense fallback={<Loader />}>
              <WriteReview />
            </React.Suspense>
          }
        />
        {/* <Route
          path={AppRouteURL.EDIT_REVIEW + ':eventId/write-a-review/:userId'}
          element={
            <React.Suspense fallback={<Loader />}>
              <WriteReview />
            </React.Suspense>
          }
        /> */}
        <Route
          path={AppRouteURL.CHECKOUT_PAYMENT}
          element={
            <React.Suspense fallback={<Loader />}>
              <CheckoutPaymentPage />
            </React.Suspense>
          }
        />
        <Route
          path={AppRouteURL.CHECKOUT_INFORMATION}
          element={
            <React.Suspense fallback={<Loader />}>
              <CheckoutInformationPage />
            </React.Suspense>
          }
        />
        <Route
          path={AppRouteURL.THANK_YOU_PURCHASE + ":orderId"}
          element={
            <React.Suspense fallback={<Loader />}>
              <PaymentSuccess />
            </React.Suspense>
          }
        />
        <Route
          path={AppRouteURL.PAYMENT_FAILED + '/' + ":orderId"}
          element={
            <React.Suspense fallback={<Loader />}>
              <PaymentFail />
            </React.Suspense>
          }
        />
        <Route
          path={AppRouteURL.ORDER_DETAIL + '/' + ":orderId"}
          element={
            <React.Suspense fallback={<Loader />}>
              <OrderDetail />
            </React.Suspense>
          }
        />

        <Route
          path={AppRouteURL.RETRY_PAYMENT}
          element={
            <React.Suspense fallback={<Loader />}>
              <RetryPayment />
            </React.Suspense>
          }
        />
        <Route
          path={AppRouteURL.COLLABORATE_WITH_US}
          element={
            <React.Suspense fallback={<Loader />}>
              <CollaborateWithUs />
            </React.Suspense>
          }
        />
        <Route
          path={AppRouteURL.DOWNLOAD_CERTIFICATE + "/:certificateId"}
          element={
            <React.Suspense fallback={<Loader />}>
              <Certificate />
            </React.Suspense>
          }
        />
        <Route
          path={AppRouteURL.PAGE_NOT_FOUND}
          element={
            <React.Suspense fallback={<Loader />}>
              <NotFound />
            </React.Suspense>
          }
        />

        <Route path='*' element={<Navigate to={AppRouteURL.PAGE_NOT_FOUND} />} />
      </Routes>
    </>
  );
}
